import React from 'react'
import styled from 'styled-components'

const Hire = () => {
  return (
    <HireWrapper>
      <div className="head">
        <span>|| Just Be It</span>
        <h1>We're In Need</h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ullam blanditiis corrupti, vitae ea atque reprehenderit?</p>
      </div>  
      <HirePosWrapper>
        <div className="pos-box">
          <div className="title">
            <h1>FrontEnd Developer</h1>
            <p>|| 2yrs Experience</p>
          </div>
          <div className="abt-pos">
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, aspernatur reprehenderit libero eligendi culpa perferendis vero enim officiis sed corporis optio animi inventore deleniti nihil...</p>
          <span>Read More</span>
          </div>
        </div>
        <div className="pos-box">
          <div className="title">
            <h1>FrontEnd Developer</h1>
            <p>|| 2yrs Experience</p>
          </div>
          <div className="abt-pos">
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, aspernatur reprehenderit libero eligendi culpa perferendis vero enim officiis sed corporis optio animi inventore deleniti nihil...</p>
          <span>Read More</span>
          </div>
        </div>
      </HirePosWrapper>
    </HireWrapper>
  )
}

const HireWrapper = styled.section`
 min-height: 100vh;
 padding: 100px 20px;
 background: rgb(0 0 0 / 5%);

 .head{
    width: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 0 auto;

    span{
        color: var(--bg-color);
        font-weight: 700;
    }

    h1{
        color: var(--bg-color);
        font-size: 2.8rem;
        font-weight: 700;
        padding: 10px 0;
    }
    p{
        color: var(--text-color);
        font-size: 1.06rem;
        font-weight: 600;
        max-width: 520px;
        line-height: 1.7;
    }
 }

 @media screen and (max-width: 430px) {
     min-height: 80vh;
    .head{
        width: 100%;
        h1{
            font-size: 2.6rem;
        }
    }
 }
`

const HirePosWrapper = styled.article`
 width: 100%;
 display: flex;
 gap: 1rem;
 flex-wrap: wrap;
 margin: 2% auto;
 padding: 5px;

 .pos-box{
    box-shadow: 0 0 10px var(--bga-color);
    background: #fff;
    border-radius: .2rem;
    display: flex;
    flex: 1 1 30rem;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 1rem;
    padding: 10px;
    margin: 1% 0;
    width: 90%;
    .title{
        display: flex;
        align-items: center;
        gap: 1rem;
        h1{
            font-size: 1.6rem;
            font-weight: 600;
            color: var(--bg-color);
        }
        p{
            font-size: 1.2rem;
            font-weight: 600;
            color: var(--ico-color);
        }
    }
    .abt-pos{
      p{
        max-width: 600px;
        font-size: 16px;
        padding-bottom: 10px;
      }
      span{
        color: var(--bg-color);
        cursor: pointer;
        text-decoration: underline;
        transition: all 600ms ease-in-out;
        &:hover{
            text-decoration: none;
        }
      }
    }
 }

 @media screen and (max-width: 430px) {
  .pos-box{
    .title{
        gap: 2.2rem;
        h1{
            font-size: 1.04rem;
        }
        p{
            font-size: 15px;
        }
    }
    .abt-pos{
        p{
            font-size: 15px;
            max-width: 600px;
        }
    }
  }
 }
`

export default Hire